<script>
import options from "./BlackthornEvent.options"

export default options;
</script>

<template>
    <section class="nyk-hero-topic-pages">
        <div class="nyk-blackthorn-event">
            <!-- Screen reader live region for status announcements -->
            <div class="nyk-visually-hidden" 
                aria-live="polite" 
                aria-atomic="true">
                {{ statusMessage }}
            </div>

            <template v-if="eventUrl && (cookieAccepted || !requireConsent)">
                <div ref="containerRef" 
                    class="nyk-blackthorn-event__container" 
                    role="region"
                    aria-label="Event registration"
                    :aria-busy="!isAppReady"></div>
            </template>

            <template v-else-if="eventUrl">
                <div class="nyk-blackthorn-event__consent-placeholder">
                    <p class="nyk-hero-topic-pages__description">{{ labels.cookieConsentMessage }}</p>
                    <NykButton 
                        variant="outline-primary"
                        @click="acceptCookieConsent">
                        {{ labels.cookieConsentButtonLabel }}
                    </NykButton>
                </div>
            </template>
        </div>
    </section>
</template>
